import React from 'react';
import FullWidthPageType from '../pageType/FullWidthPageType';

const PageTypeRenderer = ({ page }) => <FullWidthPageType page={page} />;

export default PageTypeRenderer;
